
































































































































import { OptimizationGoalItem } from '@tt4b/ttam-enums';
import { defineComponent, PropType, toRefs, ref, computed } from '@vue/composition-api';
import { cloneDeep } from 'lodash-es';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';
import { RecommendTargetDataWithLabel, RecommendTargetItem } from '../types';
import { flattenRecommendTargetData } from '../utils';
import { useRecommendTargetHas } from '../hooks';

const name = 'ttam-recommend-interest-behavior-more-dialog';

export default defineComponent({
  name,
  components: {
    TooltipInfo,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    recommendData: {
      type: Object as PropType<RecommendTargetDataWithLabel>,
      default: () => ({}),
      required: true,
    },
  },
  setup(props, { emit }) {
    const { recommendData: originRecommendData } = toRefs(props);
    const _recommendData = ref(cloneDeep(originRecommendData.value));

    const { hasInterest, hasBehavior, hasInterestKeywords } = useRecommendTargetHas({
      recommendData: originRecommendData,
    });

    const interest = computed<RecommendTargetItem[]>({
      get: () => _recommendData.value?.interest ?? [],
      set: val => {
        _recommendData.value = { ..._recommendData.value, interest: val };
      },
    });

    const interestKeywords = computed<RecommendTargetItem[]>({
      get: () => _recommendData.value?.interestKeywords ?? [],
      set: val => {
        _recommendData.value = { ..._recommendData.value, interestKeywords: val };
      },
    });

    const behavior = computed({
      get: () => _recommendData.value.behavior,
      set: val => {
        _recommendData.value = { ..._recommendData.value, behavior: val };
      },
    });

    const currentCount = computed(() => flattenRecommendTargetData(_recommendData.value)?.length);
    const showResetAlert = computed(() => !currentCount.value);

    const onCancel = () => {
      emit('close');
    };

    const onReset = () => {
      _recommendData.value = cloneDeep(originRecommendData.value);
    };

    const onRemoveInterest = (item: OptimizationGoalItem) => {
      interest.value = interest.value?.filter?.(o => o.value !== item.value);
    };

    /** 删除兴趣关键词标签 */
    function onRemoveInterestKeywords(id) {
      interestKeywords.value = interestKeywords.value.filter(item => item !== id);
    }

    const onRemoveBehavior = (item: OptimizationGoalItem, sence: keyof RecommendTargetDataWithLabel['behavior']) => {
      behavior.value[sence] = behavior.value?.[sence]?.filter?.(o => o.value !== item.value);
    };

    const onApply = () => {
      emit('apply', 'fromLearnMore', _recommendData.value);

      onCancel();
    };

    return {
      name,
      hasInterest,
      hasBehavior,
      hasInterestKeywords,
      interest,
      interestKeywords,
      behavior,
      showResetAlert,

      onApply,
      onCancel,
      onReset,
      onRemoveInterest,
      onRemoveBehavior,
      onRemoveInterestKeywords,
    };
  },
});
